module.exports = __webpack_public_path__ + "static/parapura2-7c1514666f0d9a3eb8787eac71c9a782.jpg";